import { render } from "./MultiTrendChart.vue?vue&type=template&id=b0ccb53e"
import script from "./MultiTrendChart.vue?vue&type=script&lang=js"
export * from "./MultiTrendChart.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2135/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__